import { User } from "callable-data-objects";
import { useUser } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import {
  Breadcrumb,
  Button,
  Container,
  Label,
  Menu,
  Table,
} from "semantic-ui-react";
import OrganisationUserCreate from "./OrganisationUserCreate";
import UserDetails from "./UserDetails";

const OrganisationUsers = () => {
  const {
    users,
    user,
    select,
    loading,
    unselect,
    revokeAccount,
    inviteAccount,
    revokeRole,
    inviteRole,
    update,
    organisation,
    createUser,
    onCreateUser,
  } = useUser();

  if (createUser) {
    return <OrganisationUserCreate />;
  }

  return (
    <Container fluid>
      <Menu stackable>
        <Menu.Item header>
          <Breadcrumb>
            {!user && <Breadcrumb.Section>Users</Breadcrumb.Section>}
            {user && (
              <Fragment>
                <Breadcrumb.Section link onClick={() => unselect()}>
                  Users
                </Breadcrumb.Section>
                <Breadcrumb.Divider />
                <Breadcrumb.Section>{user.email}</Breadcrumb.Section>
              </Fragment>
            )}
          </Breadcrumb>
        </Menu.Item>
        {!user && (
          <Menu.Menu position='right'>
            <Menu.Item>
              <Button primary onClick={onCreateUser}>
                Create User
              </Button>
            </Menu.Item>
          </Menu.Menu>
        )}
      </Menu>
      {!user && (
        <Table singleLine stackable padded striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Email</Table.HeaderCell>
              <Table.HeaderCell>First Name</Table.HeaderCell>
              <Table.HeaderCell>Last Name</Table.HeaderCell>
              <Table.HeaderCell>Roles</Table.HeaderCell>
              <Table.HeaderCell>Accounts</Table.HeaderCell>
              <Table.HeaderCell>Actions</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {users.map((user: User) => (
              <Table.Row key={user.email}>
                <Table.Cell width={3}>{user.email}</Table.Cell>
                <Table.Cell width={4}>{user.firstName}</Table.Cell>
                <Table.Cell width={4}>{user.lastName}</Table.Cell>
                <Table.Cell width={3}>
                  {user.groups.map((g) => (
                    <Label size='small' basic color='green'>
                      {g}
                    </Label>
                  ))}
                </Table.Cell>
                <Table.Cell width={1}>
                  <Label basic color='purple'>
                    {user.customers?.length || 0}
                  </Label>
                </Table.Cell>
                <Table.Cell width={1}>
                  <Button primary onClick={() => select(user.id)}>
                    View
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
      {user && (
        <UserDetails
          user={user}
          unselect={unselect}
          loading={loading}
          update={update}
          organisation={organisation}
          revokeAccount={revokeAccount}
          inviteAccount={inviteAccount}
          revokeRole={revokeRole}
          inviteRole={inviteRole}
        />
      )}
    </Container>
  );
};

export default OrganisationUsers;
